/*
 * HelloSpicy — Barre de progression « livraison offerte ».
 *
 * Deux bugs corrigés par rapport à la version précédente :
 *
 * 1. L'abonnement aux événements panier ne se faisait JAMAIS.
 *    Le garde-fou testait `window.PUB_SUB_EVENTS`, or Dawn déclare cette constante
 *    avec `const` dans un script classique : elle vit dans la portée lexicale
 *    globale mais n'est PAS une propriété de `window`. Mesuré dans la console :
 *      typeof window.PUB_SUB_EVENTS → "undefined"
 *      typeof PUB_SUB_EVENTS        → "object"
 *    D'où l'obligation d'actualiser la page pour voir un changement.
 *    On teste désormais l'identifiant nu via `typeof`.
 *
 * 2. Repli robuste : si l'événement ne transporte pas les totaux, on relit /cart.js
 *    plutôt que d'abandonner silencieusement.
 */
(function () {
  var SELECTOR = '[data-hs-shipping-bar]';

  function formatEuros(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function render(bar, totalCents, itemCount) {
    var threshold = parseInt(bar.getAttribute('data-threshold-cents'), 10) || 3500;
    var unlockedText = bar.getAttribute('data-unlocked-text') || 'Livraison offerte débloquée';
    var remainingTpl = bar.getAttribute('data-remaining-template') || 'Plus que {amount} pour la livraison offerte';

    var remaining = Math.max(0, threshold - totalCents);
    var pct = threshold > 0 ? Math.min(100, (totalCents / threshold) * 100) : 100;
    var pctRounded = Math.round(pct);
    var unlocked = remaining <= 0;

    bar.hidden = itemCount <= 0;
    bar.classList.toggle('hs-ship--unlocked', unlocked);

    var fill = bar.querySelector('[data-hs-ship-fill]');
    if (fill) fill.style.width = pct.toFixed(2) + '%';

    var head = bar.querySelector('[data-hs-ship-head]');
    if (head) head.style.left = pct.toFixed(2) + '%';

    var track = bar.querySelector('[data-hs-ship-track]');
    if (track) {
      track.setAttribute('aria-valuenow', pctRounded);
      track.setAttribute(
        'aria-valuetext',
        unlocked
          ? unlockedText
          : pctRounded + '% du seuil atteint, ' + remainingTpl.replace('{amount}', formatEuros(remaining))
      );
    }

    var msg = bar.querySelector('[data-hs-ship-message]');
    if (msg) {
      if (unlocked) {
        msg.textContent = unlockedText;
      } else {
        msg.textContent = '';
        var parts = remainingTpl.split('{amount}');
        msg.appendChild(document.createTextNode(parts[0]));
        var strong = document.createElement('strong');
        strong.className = 'hs-ship__amount';
        strong.textContent = formatEuros(remaining);
        msg.appendChild(strong);
        if (parts[1]) msg.appendChild(document.createTextNode(parts[1]));
      }
    }
  }

  function applyCart(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;
    var itemCount = typeof cart.item_count === 'number' ? cart.item_count : (cart.total_price > 0 ? 1 : 0);
    document.querySelectorAll(SELECTOR).forEach(function (bar) {
      render(bar, cart.total_price, itemCount);
    });
  }

  function refetch() {
    fetch(window.routes && window.routes.cart_url ? window.routes.cart_url + '.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(applyCart)
      .catch(function () { /* silencieux : la barre garde son état rendu par Liquid */ });
  }

  function onCartUpdate(event) {
    var data = event && event.cartData;
    if (data && typeof data.total_price === 'number') {
      applyCart(data);
    } else {
      refetch();
    }
  }

  function init() {
    if (!document.querySelector(SELECTOR)) return;

    // ⚠️ `PUB_SUB_EVENTS` est un `const` global lexical, absent de `window`.
    var hasPubSub = typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
    if (hasPubSub) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
      if (PUB_SUB_EVENTS.cartError) subscribe(PUB_SUB_EVENTS.cartError, refetch);
      if (PUB_SUB_EVENTS.quantityUpdate) subscribe(PUB_SUB_EVENTS.quantityUpdate, refetch);
    }

    // Filet de sécurité : certaines apps modifient le panier sans publier d'événement.
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') refetch();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
